// modules/fadeUp.js
export function fadeUp() {
  const fadeSections = document.querySelectorAll('.fade-up');
  if (!fadeSections.length) return;

  fadeSections.forEach(section => {
    const items = section.querySelectorAll(':scope > *'); // directe kinderen
    if (!items.length) return;

    gsap.set(items, { opacity: 0, y: 40 });

    ScrollTrigger.batch(items, {
      interval: 0.1,
      onEnter: batch => {
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          stagger: 0.15,
          duration: 0.6,
          ease: 'power2.out',
          overwrite: true
        });
      },
      once: true
    });
  });
}
